import config from 'config';

import { Box, useTheme } from '@chakra-ui/react';

import { formatCurrency } from 'utils';

import { DepositOptionsInterface } from 'types';

import { Text } from 'ui';

const {
  booking: {
    review: {
      infoBox: { title, subTitle, description, boldDescription }
    }
  }
} = config;

interface DepositRequiredMessageProps {
  options: DepositOptionsInterface | null;
  sum: number;
}

const DepositRequiredMessage = ({
  sum,
  options
}: DepositRequiredMessageProps) => {
  const {
    colors: {
      palette: {
        booking: {
          stepReview: { requiredDdescription }
        }
      }
    }
  } = useTheme();

  const getTitle = () => {
    if (options?.req_guarantee) {
      return 'Credit Card Deposit Required to Complete Booking';
    }

    const remainPrice =
      sum === options?.deposit_amount ? '' : `${formatCurrency(sum, true)} of `;

    return sum === 0
      ? 'Click Next to Complete Booking'
      : `${remainPrice}${formatCurrency(
          options?.deposit_amount ?? 0,
          true
        )} ${title}`;
  };

  const reqOption = options?.req_guarantee ? 'credit card' : 'deposit';

  return (
    <Box my='50px'>
      <Text
        mt='2px'
        fontSize={{ base: '22px', md: '26px', lg: '28px' }}
        lineHeight={{ base: '31px', md: '35px', lg: '37px' }}
        color={requiredDdescription.title}
        fontWeight='semibold'
        textAlign='center'
      >
        {getTitle()}
      </Text>
      <Text
        fontSize={{ base: '20px', md: '22px', lg: '24px' }}
        lineHeight={{ base: '28px', md: '30px', lg: '32px' }}
        color={requiredDdescription.subTitle}
        fontWeight='regular'
        py={{ base: 3, md: 5 }}
        textAlign='center'
      >
        {`A ${reqOption} ${subTitle}`}
      </Text>

      <Box
        bg={requiredDdescription.boxBg}
        mx={{ base: 0, lg: '75px' }}
        py={{ base: '14px', md: '28px' }}
        px={{ base: '20px', md: '50px' }}
        borderRadius='8px'
      >
        <Text
          fontSize={{ base: '16px', md: '18px', lg: '20px' }}
          lineHeight={{ base: '28px', md: '30px', lg: '32px' }}
          color={requiredDdescription.description}
          fontWeight='regular'
          textAlign='center'
        >
          {description}
        </Text>
        <Text
          fontSize={{ base: '16px', md: '18px', lg: '20px' }}
          lineHeight={{ base: '28px', md: '30px', lg: '32px' }}
          color={requiredDdescription.description}
          fontWeight='semibold'
          textAlign='center'
        >
          {boldDescription}
        </Text>
      </Box>
    </Box>
  );
};

export default DepositRequiredMessage;
